import React from 'react';

export default function CurrentReceiptEmailStatus({ status, retry }) {
  if (status === 'loading') return <p role="status" className="mt-1 text-xs text-slate-600">거래처 이메일을 확인하고 있습니다.</p>;
  if (status === 'empty') return <p role="status" className="mt-1 text-xs text-slate-600">등록된 거래처 이메일이 없습니다. 직접 입력해 주세요.</p>;
  if (status === 'invalid') return <p role="status" className="mt-1 text-xs text-amber-700">거래처 이메일 형식을 확인할 수 없습니다. 직접 입력해 주세요.</p>;
  if (status === 'error') return <p role="alert" className="mt-1 text-xs text-amber-700">거래처 이메일을 조회하지 못했습니다. 직접 입력하거나 <button type="button" onClick={retry} className="font-semibold underline">다시 조회</button>해 주세요.</p>;
  return null;
}
